/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Record_ } from "./Record_";
export const Records = core.serialization.list(Record_);
